import React, { useState } from 'react';
import { usePortalListing } from 'api/apiHooks';
import useAuth from 'hooks/useAuth';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { getDateDiffInDays } from 'utils/getDateDiffInDays';
import { Banner } from 'components/elements';
import { Button } from '@mui/material';
import { RESET_ONBOARDING_PASSWORD } from 'api/apiConstants';
import { useSnackbar } from 'notistack';
import CircleSpinner from 'components/CircleSpinner';
import axiosInstance from 'utils/axios';

function GlobalBanner() {
  const { user } = useAuth();
  const [loading, setLoading] = useState(false);
  const { enqueueSnackbar } = useSnackbar();
  const { data } = usePortalListing();
  const { t } = useTranslation();
  const { portalId } = useParams<{
    portalId: string;
  }>();
  const activePortal = data?.data.filter(function (portal) {
    return portal.portal_id.toString() === portalId;
  });
  let date = null;
  let notice = null;
  if (activePortal?.length && activePortal[0].payment_plan.type === 'trial') {
    date = getDateDiffInDays(
      parseInt(activePortal[0].payment_plan.validity as unknown as string)
    );
    if (date > 1) {
      notice = t('you_have_only') + ' ' + date + ' ' + t('left_in_trial');
    } else {
      notice = t('your_trial') + ' ' + t('will_expire_today');
    }
  }

  const sendPasswordSetMail = async (params: any) => {
    setLoading(true);
    await axiosInstance
      .post(
        RESET_ONBOARDING_PASSWORD,

        {
          headers: { 'Content-Type': 'multipart/form-data' },
        }
      )
      .then(response => {
        setLoading(false);
        enqueueSnackbar('Mail has been successfully sent', {
          variant: 'success',
        });
      });
  };

  return (
    <>
      {/* conditionally rendering the banner */}
      {user?.reset_password_onboarding === false ? (
        <Banner>
          {t('set_login_password')}{' '}
          <div className='w-[70px] ml-1 mr-1'>
            {loading ? (
              <CircleSpinner />
            ) : (
              <Button
                className='text-white p-0 bg-transparent flex justify-items-center align-items-center'
                onClick={sendPasswordSetMail}
                variant='text'
              >
                {t('click')}
              </Button>
            )}
          </div>{' '}
          {t('to_send_mail')}
        </Banner>
      ) : (
        <>{notice && <Banner>{notice}</Banner>}</>
      )}
    </>
  );
}

export default GlobalBanner;
